/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Spinner, Tabs, Dropdown, Tab } from "react-bootstrap";
import useHiringManagerJobs from "./useHiringManagerJobs";
import { useNavigate } from "react-router-dom";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MainLayout from "../../Common/MainLayout";
import CustomImage from "../../Common/CustomImage";
import { dateDiff } from "../../../_helpers/dateFormatter";
export default () => {
  const navigate = useNavigate();

  const { loading, jobsPosted, onCreateJobClick } = useHiringManagerJobs();

  const publishedJobs =
    jobsPosted?.results &&
    jobsPosted.results.filter((job) => job?.status === "publish");
  const draftJobs =
    jobsPosted?.results &&
    jobsPosted.results.filter((job) => job?.status === "draft");
  return (
    <MainLayout activeMenuItem="jobs" pageName="Jobs">
      <Container>
        <div className="applied-job-board footer-gap">
          <div className="hiring-process-dashboard kanban-board-main mt-4">
            <Tabs defaultActiveKey="PublishedJobs" className="my-4">
              <Tab eventKey="PublishedJobs" title="Published Jobs">
                <div className="mb-4 job-list-section">
                  {loading ? (
                    <>
                      <div className="d-flex align-items-center justify-content-center p-4">
                        <Spinner animation="border" variant="primary" />
                      </div>
                    </>
                  ) : (
                    <>
                      {" "}
                      {Array.isArray(publishedJobs) && publishedJobs?.length ? (
                        <>
                          <div className="row">
                            {publishedJobs &&
                              Array.isArray(publishedJobs) &&
                              publishedJobs.map((data, index) => (
                                <div className="col-lg-6 mb-4">
                                  <div className="p-4 bg-white border position-relative h-100 rounded-lg shadow-2">
                                    <div className="upper mb-2">
                                      <div className="d-flex justify-content-between">
                                        <div className="d-flex mb-3 align-items-start">
                                          <CustomImage
                                            src={
                                              data?.posted_by_details &&
                                              data.posted_by_details
                                                ?.company_details &&
                                              data.posted_by_details
                                                .company_details?.logo
                                                ? data?.posted_by_details &&
                                                  data.posted_by_details
                                                    ?.company_details &&
                                                  data.posted_by_details
                                                    .company_details?.logo
                                                : "/assets/images/building-placeholder.png"
                                            }
                                            classes={"border-radius-10 mr-3"}
                                            width={48}
                                            height={48}
                                          />

                                          <div className="job-info flex-grow-1">
                                            <h3 className="mb-1 text-4 text-capitalize">
                                              {data?.title}
                                            </h3>
                                            <p className="mb-1 fs-14 text-capitalize">
                                              <span className="text-grey-4">
                                                {data?.city_name}
                                                {data?.city_name ? ", " : null}
                                                {data?.state_name}
                                                {data?.city_name ? ", " : null}
                                              </span>
                                              <span className="text-uppercase text-grey-4">
                                                {data?.country_name}
                                              </span>
                                            </p>
                                          </div>
                                        </div>

                                        <Dropdown>
                                          <Dropdown.Toggle
                                            variant=""
                                            className="no-dropdown-arrow pr-0"
                                          >
                                            <img
                                              src="/assets/images/ellipse-v.svg"
                                              alt="options"
                                            />
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu>
                                            <ul>
                                              <li
                                                className="px-3 cursor-pointer"
                                                onClick={(e) => {
                                                  navigate(
                                                    `/create-job/${data.id}`,
                                                    {
                                                      state: data?.id,
                                                    }
                                                  );
                                                }}
                                              >
                                                Edit
                                              </li>
                                            </ul>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>

                                      <ul className="d-flex flex-wrap">
                                        <li className="bg-grey my-1 px-1 border rounded-pill py-1 fs-smallest mr-2">
                                          Applied:{" "}
                                          <span className="custom-tag tag-applied inline-block px-2 py-1 rounded-pill">
                                            {data?.candidates_at_different_stages &&
                                              data
                                                .candidates_at_different_stages
                                                ?.applied}
                                          </span>
                                        </li>
                                        <li className="bg-grey text-capitalize my-1 px-1 border rounded-pill py-1 fs-smallest mr-2">
                                          Assessment:{" "}
                                          <span className="custom-tag tag-assessment inline-block px-2 py-1 rounded-pill">
                                            {data?.candidates_at_different_stages &&
                                              data
                                                .candidates_at_different_stages
                                                ?.assessment}
                                          </span>
                                        </li>
                                        <li className="bg-grey text-capitalize my-1 px-1 border rounded-pill py-1 fs-smallest mr-2">
                                          interview:{" "}
                                          <span className="custom-tag tag-interview inline-block px-2 py-1 rounded-pill">
                                            {data?.candidates_at_different_stages &&
                                              data
                                                .candidates_at_different_stages
                                                ?.interview}
                                          </span>
                                        </li>

                                        <li className="bg-grey text-capitalize my-1 px-1 border rounded-pill py-1 fs-smallest mr-2">
                                          offer:{" "}
                                          <span className="custom-tag tag-offer inline-block px-2 py-1 rounded-pill">
                                            {data?.candidates_at_different_stages &&
                                              data
                                                .candidates_at_different_stages
                                                ?.offer}
                                          </span>
                                        </li>
                                        <li className="bg-grey text-capitalize my-1 px-1 border rounded-pill py-1 fs-smallest mr-2">
                                          hired:{" "}
                                          <span className="custom-tag tag-green inline-block px-2 py-1 rounded-pill">
                                            {data?.candidates_at_different_stages &&
                                              data
                                                .candidates_at_different_stages
                                                ?.hired}
                                          </span>
                                        </li>
                                        <li className="bg-grey text-capitalize my-1 px-1 border rounded-pill py-1 fs-smallest mr-2">
                                          rejected:{" "}
                                          <span className="custom-tag tag-rejected inline-block px-2 py-1 rounded-pill">
                                            {data?.candidates_at_different_stages &&
                                              data
                                                .candidates_at_different_stages
                                                ?.rejected}
                                          </span>
                                        </li>
                                      </ul>
                                    </div>

                                    <div>
                                      {data?.mentor_name ? (
                                        <>
                                          <div
                                            className="mb-0 mr-2 d-flex align-items-center cursor-pointer"
                                            onClick={() => {
                                              navigate(
                                                `/view-mentor-profile/${data?.mentor_job_application_id}`,
                                                {
                                                  state: {
                                                    id: data?.mentor_job_application_id,
                                                    jobTitle: data?.title,
                                                  },
                                                }
                                              );
                                            }}
                                          >
                                            <CustomImage
                                              src={
                                                "/assets/images/avatar-gray.svg"
                                              }
                                              classes={"rounded-circle img-fit"}
                                              width={40}
                                              height={40}
                                            />
                                            <div className=" ml-2">
                                              <p className="text-capitalize mb-0 font-weight-bold">
                                                {data?.mentor_name}{" "}
                                              </p>
                                              <span className="text-grey-4 fs-smallest">
                                                is assigned
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div
                                            className="mb-0 mr-2 d-flex align-items-center cursor-pointer"
                                            onClick={() =>
                                              navigate(
                                                `/view-mentors-applied/${data?.id}`,
                                                {
                                                  state: data?.id,
                                                }
                                              )
                                            }
                                          >
                                            <CustomImage
                                              src={
                                                "/assets/images/avatar-gray.svg"
                                              }
                                              classes={"rounded-circle img-fit"}
                                              width={40}
                                              height={40}
                                            />
                                            <div className=" ml-2">
                                              <p className="text-capitalize mb-0 font-weight-bold">
                                                Mentors Applied
                                              </p>
                                              <span className="text-grey-4 fs-smallest">
                                                {data?.total_mentors}
                                              </span>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                    <div className="d-flex border-top pt-3 justify-content-between align-items-center mt-3 ">
                                      <span className="text-grey-4">
                                        Posted{" "}
                                        {dateDiff(data.created, new Date())} ago
                                      </span>

                                      <button
                                        className="text-primary font-weight-semi border-0 bg-transparent"
                                        onClick={(e) => {
                                          navigate(
                                            `/hiring-manager-kanboard/${data.id}`,
                                            {
                                              state: data?.id,
                                            }
                                          );
                                        }}
                                      >
                                        View Job
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </>
                      ) : (
                        <div className="text-center">
                          <div className="msg-bg text-white p-3 border-6 mb-3 mt-4 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
                            <p className="mb-0">
                              <FontAwesomeIcon
                                icon={faCircleInfo}
                                className="text-white mr-2"
                              />
                              No jobs is published yet.
                            </p>
                          </div>
                          <button
                            className="btn btn-primary"
                            onClick={onCreateJobClick}
                          >
                            Create A New Job
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Tab>
              <Tab eventKey="DraftedJobs" title="Drafted Jobs">
                <div className="mb-4 job-list-section">
                  {loading ? (
                    <>
                      <div className="d-flex align-items-center justify-content-center p-4">
                        <Spinner animation="border" variant="primary" />
                      </div>
                    </>
                  ) : (
                    <>
                      {" "}
                      {Array.isArray(draftJobs) && draftJobs?.length ? (
                        <>
                          <div className="row">
                            {draftJobs &&
                              Array.isArray(draftJobs) &&
                              draftJobs.map((data, index) => (
                                <div className="col-md-6 mb-4">
                                  <div className="p-4 bg-white border position-relative h-100 rounded-lg shadow-2">
                                    <div className="upper">
                                      <div className="d-flex justify-content-between">
                                        <div className="d-flex mb-3 align-items-start">
                                          <CustomImage
                                            src={
                                              data?.posted_by_details &&
                                              data.posted_by_details
                                                ?.company_details &&
                                              data.posted_by_details
                                                .company_details?.logo
                                                ? data?.posted_by_details &&
                                                  data.posted_by_details
                                                    ?.company_details &&
                                                  data.posted_by_details
                                                    .company_details?.logo
                                                : "/assets/images/building-placeholder.png"
                                            }
                                            classes={"border-radius-10 mr-3"}
                                            width={48}
                                            height={48}
                                          />

                                          <div className="job-info flex-grow-1">
                                            <h3 className="mb-1 text-4 text-capitalize">
                                              {data?.title}
                                            </h3>
                                            <p className="mb-1 fs-14 text-capitalize">
                                              <span className="text-grey-4">
                                                {data?.city_name}
                                                {data?.city_name ? ", " : null}
                                                {data?.state_name}
                                                {data?.city_name ? ", " : null}
                                              </span>
                                              <span className="text-uppercase text-grey-4">
                                                {data?.country_name}
                                              </span>
                                            </p>
                                          </div>
                                        </div>

                                        <Dropdown>
                                          <Dropdown.Toggle
                                            variant=""
                                            className="no-dropdown-arrow pr-0"
                                          >
                                            <img
                                              src="/assets/images/ellipse-v.svg"
                                              alt="options"
                                            />
                                          </Dropdown.Toggle>

                                          <Dropdown.Menu>
                                            <ul>
                                              <li
                                                className="px-3 cursor-pointer"
                                                onClick={(e) => {
                                                  navigate(
                                                    `/create-job/${data.id}`,
                                                    {
                                                      state: data?.id,
                                                    }
                                                  );
                                                }}
                                              >
                                                Edit
                                              </li>
                                            </ul>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      </div>
                                      <p className="text-warning font-weight-semi">
                                        Publish job to source candidates
                                      </p>
                                    </div>
                                    <div className="d-flex border-top pt-3 justify-content-between align-items-center mt-3 ">
                                      <span className="text-grey-4">
                                        Posted{" "}
                                        {dateDiff(data.created, new Date())} ago
                                      </span>

                                      <button
                                        className="text-primary font-weight-semi border-0 bg-transparent"
                                        onClick={(e) => {
                                          navigate(
                                            `/hiring-manager-kanboard/${data.id}`,
                                            {
                                              state: data?.id,
                                            }
                                          );
                                        }}
                                      >
                                        View Job
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        </>
                      ) : (
                        <div className="text-center">
                          <div className="msg-bg text-white p-3 border-6 mb-3 mt-4 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
                            <p className="mb-0">
                              <FontAwesomeIcon
                                icon={faCircleInfo}
                                className="text-white mr-2"
                              />
                              No jobs in draft.
                            </p>
                          </div>
                          <button
                            className="btn btn-primary mt-4"
                            onClick={() => navigate("/create-job")}
                          >
                            Create A New Job
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </Container>
    </MainLayout>
  );
};
